module.exports = __webpack_public_path__ + "img/curtomerIcon.e6de63f0.png";